export default __webpack_public_path__ + "static/media/terms.bf3477e9.md";